export default {
    cn: {
        publicLan: {
            type: {
                SL: '销售',
                M: '经理',
                IB: '代理',
                CL: '客户',
                extraEmployee: '额外员工',
                specialIB: '特别代理',
                employee: '员工',
                UN: "系统",
                C: '公司',
                N: '国家',
                R: '地区',
                O: '办事处',
                M: '经理',
            },
            relationType: {
                relation: '关系图',
                extra: '佣金转发',
                special: '额外添加'
            },
            clientType: {
                allClient: '全部客戶',
                IBClient: '代理客户',
                directClient: '直接客户',
            },
            rule: {
                percentage: "百分比",
                extrapercentage: "额外百分比",
                maxlevel: "分层最高金额(按佣金)",
                fixamount: "固定金额",
                maxlevel2: "分层最高金额(自定金额)",
                maxdiff: "与最高内返相差",
                fixamountnonvip: "固定金额(普通组别)",
                fixamountvip: "固定金额(VIP组别)",
                percentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 分 配 ，總 設 定 不 超 過 100 % 。',
                extrapercentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 計 算 ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                maxlevel_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
                maxlevel2_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
                fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                maxdiff_desc: '按 即 月 交 易 量 達 到 的 內 返 條 件 , 與 最 高 內 返 條 件 的 相 差 來 分 配 佣 金  。相 差 的 金 額 以 輸 入 的 上 限 由 下 到 上 來 分 配 。',
                fixamountnonvip_desc: '針 對 普 通 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                fixamountvip_desc: '針 對 V I P 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            },
            products: {
                ALL: '全部',

                FX: '外汇',
                FX_VIP: '外汇(VIP)',
                GOLD: '黄金',
                GOLD_VIP: '黄金(VIP)',
                SILVER: '白银',
                SILVER_VIP: '白银(VIP)',
                ENERGY: '能源',
                ENERGY_VIP: '能源(VIP)',
                INDEX: '指数',
                INDEX_VIP: '指数(VIP)',
                FX_MAJOR: '外汇(主要)',
                FX_MAJOR_VIP: '外汇(主要)(VIP)',
                FX_MINOR: '外汇(次要)',
                FX_MINOR_VIP: '外汇(次要)(VIP)',
                FX_EXOTIC: '外汇(其他)',
                FX_EXOTIC_VIP: '外汇(其他)(VIP)',
                BTC: '比特币',
                BTC_VIP: '比特币(VIP)',
                ETH_LTC: '以太币&莱特币',
                ETH_LTC_VIP: '以太币&莱特币(VIP)',
                FUTURE_GOLD: '黄金期货',
                FUTURE_GOLD_VIP: '黄金期货(VIP)',
                FUTURE_SILVER: '白银期货',
                FUTURE_SILVER_VIP: '白银期货(VIP)',
                FUTURE_COPPER: '黄铜期货',
                FUTURE_COPPER_VIP: '黄铜期货(VIP)',
                FUTURE_NATGAS: '天然气期货',
                FUTURE_NATGAS_VIP: '天然气期货(VIP)',
                COPPER: '铜',
                COPPER_VIP: '铜(VIP)',
            },
            detailTh: {
                IB_ID: '代理账号',
                CLIENT_ID: '客户账号',
                PLATFORM: '交易平台',
                TRADING_ACCOUNT_ID: '交易账号',

                FX_LOT: '外汇(手数)',
                FX_REBATE_DIFF: '外汇(每手差值)',
                FX_COMMISSION_DIFF: '外汇(额外佣金)',
                FX_VIP_LOT: '外汇(VIP)(手数)',
                FX_VIP_REBATE_DIFF: '外汇(VIP)(每手差值)',
                FX_VIP_COMMISSION_DIFF: '外汇(VIP)(额外佣金)',

                GOLD_LOT: '黄金(手数)',
                GOLD_REBATE_DIFF: '黄金(每手差值)',
                GOLD_COMMISSION_DIFF: '黄金(额外佣金)',
                GOLD_VIP_LOT: '黄金(VIP)(手数)',
                GOLD_VIP_REBATE_DIFF: '黄金(VIP)(每手差值)',
                GOLD_VIP_COMMISSION_DIFF: '黄金(VIP)(额外佣金)',

                SILVER_LOT: '白银(手数)',
                SILVER_REBATE_DIFF: '白银(每手差值)',
                SILVER_COMMISSION_DIFF: '白银(额外佣金)',
                SILVER_VIP_LOT: '白银(VIP)(手数)',
                SILVER_VIP_REBATE_DIFF: '白银(VIP)(每手差值)',
                SILVER_VIP_COMMISSION_DIFF: '白银(VIP)(额外佣金)',

                ENERGY_LOT: '能源(手数)',
                ENERGY_REBATE_DIFF: '能源(每手差值)',
                ENERGY_COMMISSION_DIFF: '能源(额外佣金)',
                ENERGY_VIP_LOT: '能源((VIP)(手数)',
                ENERGY_VIP_REBATE_DIFF: '能源((VIP)(每手差值)',
                ENERGY_VIP_COMMISSION_DIFF: '能源((VIP)(额外佣金)',

                INDEX_LOT: '指数(手数)',
                INDEX_REBATE_DIFF: '指数(每手差值)',
                INDEX_COMMISSION_DIFF: '指数(额外佣金)',
                INDEX_VIP_LOT: '指数(VIP)(手数)',
                INDEX_VIP_REBATE_DIFF: '指数(VIP)(每手差值)',
                INDEX_VIP_COMMISSION_DIFF: '指数(VIP)(额外佣金)',

                FX_MAJOR_LOT: '外汇(主要)(手数)',
                FX_MAJOR_REBATE_DIFF: '外汇(主要)(每手差值)',
                FX_MAJOR_COMMISSION_DIFF: '外汇(主要)(额外佣金)',
                FX_MAJOR_VIP_LOT: '外汇(主要)(VIP)(手数)',
                FX_MAJOR_VIP_REBATE_DIFF: '外汇(主要)(VIP)(每手差值)',
                FX_MAJOR_VIP_COMMISSION_DIFF: '外汇(主要)(VIP)(额外佣金)',

                FX_MINOR_LOT: '外汇(次要)(手数)',
                FX_MINOR_REBATE_DIFF: '外汇(次要)(每手差值)',
                FX_MINOR_COMMISSION_DIFF: '外汇(次要)(额外佣金)',
                FX_MINOR_VIP_LOT: '外汇(次要)(VIP)(手数)',
                FX_MINOR_VIP_REBATE_DIFF: '外汇(次要)(VIP)(每手差值)',
                FX_MINOR_VIP_COMMISSION_DIFF: '外汇(次要)(VIP)(额外佣金)',

                FX_EXOTIC_LOT: '外汇(其他)(手数)',
                FX_EXOTIC_REBATE_DIFF: '外汇(其他)(每手差值)',
                FX_EXOTIC_COMMISSION_DIFF: '外汇(其他)(额外佣金)',
                FX_EXOTIC_VIP_LOT: '外汇(其他)(VIP)(手数)',
                FX_EXOTIC_VIP_REBATE_DIFF: '外汇(其他)(VIP)(每手差值)',
                FX_EXOTIC_VIP_COMMISSION_DIFF: '外汇(其他)(VIP)(额外佣金)',

                BTC_LOT: '比特币(手数)',
                BTC_REBATE_DIFF: '比特币(每手差值)',
                BTC_COMMISSION_DIFF: '比特币(额外佣金)',
                BTC_VIP_LOT: '比特币(VIP)(手数)',
                BTC_VIP_REBATE_DIFF: '比特币(VIP)(每手差值)',
                BTC_VIP_COMMISSION_DIFF: '比特币(VIP)(额外佣金)',

                ETH_LTC_LOT: '以太币&莱特币(手数)',
                ETH_LTC_REBATE_DIFF: '以太币&莱特币(每手差值)',
                ETH_LTC_COMMISSION_DIFF: '以太币&莱特币(额外佣金)',
                ETH_LTC_VIP_LOT: '以太币&莱特币(VIP)(手数)',
                ETH_LTC_VIP_REBATE_DIFF: '以太币&莱特币(VIP)(每手差值)',
                ETH_LTC_VIP_COMMISSION_DIFF: '以太币&莱特币(VIP)(额外佣金)',

                FUTURE_GOLD_LOT: '黄金期货(手数)',
                FUTURE_GOLD_REBATE_DIFF: '黄金期货(每手差值)',
                FUTURE_GOLD_COMMISSION_DIFF: '黄金期货(额外佣金)',
                FUTURE_GOLD_VIP_LOT: '黄金期货(VIP)(手数)',
                FUTURE_GOLD_VIP_REBATE_DIFF: '黄金期货(VIP)(每手差值)',
                FUTURE_GOLD_VIP_COMMISSION_DIFF: '黄金期货(VIP)(额外佣金)',

                FUTURE_SILVER_LOT: '白银期货(手数)',
                FUTURE_SILVER_DIFF: '白银期货(每手差值)',
                FUTURE_SILVER_COMMISSION_DIFF: '白银期货(额外佣金)',
                FUTURE_SILVER_VIP_LOT: '白银期货(VIP)(手数)',
                FUTURE_SILVER_VIP_REBATE_DIFF: '白银期货(VIP)(每手差值)',
                FUTURE_SILVER_VIP_COMMISSION_DIFF: '白银期货(VIP)(额外佣金)',

                FUTURE_COPPER_LOT: '黄铜期货(手数)',
                FUTURE_COPPER_REBATE_DIFF: '黄铜期货(每手差值)',
                FUTURE_COPPER_COMMISSION_DIFF: '黄铜期货(额外佣金)',
                FUTURE_COPPER_VIP_LOT: '黄铜期货(VIP)(手数)',
                FUTURE_COPPER_VIP_REBATE_DIFF: '黄铜期货(VIP)(每手差值)',
                FUTURE_COPPER_VIP_COMMISSION_DIFF: '黄铜期货(VIP)(额外佣金)',

                FUTURE_NATGAS_LOT: '天然气期货(手数)',
                FUTURE_NATGAS_REBATE_DIFF: '天然气期货(每手差值)',
                FUTURE_NATGAS_COMMISSION_DIFF: '天然气期货(额外佣金)',
                FUTURE_NATGAS_VIP_LOT: '天然气期货(VIP)(手数)',
                FUTURE_NATGAS_VIP_REBATE_DIFF: '天然气期货(VIP)(每手差值)',
                FUTURE_NATGAS_VIP_COMMISSION_DIFF: '天然气期货(VIP)(额外佣金)',

                COPPER_LOT: '铜(手数)',
                COPPER_REBATE_DIFF: '铜(每手差值)',
                COPPER_COMMISSION_DIFF: '铜(额外佣金)',
                COPPER_VIP_LOT: '铜(VIP)(手数)',
                COPPER_VIP_REBATE_DIFF: '铜(VIP)(每手差值)',
                COPPER_VIP_COMMISSION_DIFF: '铜(VIP)(额外佣金)',
            },
            notNumber: '不是正整数，请检查输入'
        }
    },
    hk: {
        publicLan: {
            type: {
                SL: '銷售',
                M: '經理',
                IB: '代理',
                CL: '客戶',
                extraEmployee: '額外員工',
                specialIB: '特別代理',
                employee: '員工',
                UN: "系統",
                C: '公司',
                N: '國家',
                R: '地區',
                O: '辦事處',
                M: '經理',
            },
            relationType: {
                relation: '關系圖',
                extra: '傭金轉發',
                special: '額外添加'
            },
            clientType: {
                allClient: '全部客戶',
                IBClient: '代理客户',
                directClient: '直接客户',
            },
            rule: {
                percentage: "百分比",
                extrapercentage: "額外百分比",
                maxlevel: "分層最高金額(按佣金)",
                fixamount: "固定金額",
                maxlevel2: "分層最高金額(自定金額)",
                maxdiff: "與最高內返相差",
                fixamountnonvip: "固定金額(普通組別)",
                fixamountvip: "固定金額(VIP組別)",
                percentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 分 配 ，總 設 定 不 超 過 100 % 。',
                extrapercentage_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 百 分 比 計 算 ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                maxlevel_desc: '以 下 方 所 選 的 佣 金 類 型  ，按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
                maxlevel2_desc: '按 照 輸 入 的 金 額 作 上 限 由 下 到 上 來 分 配 。',
                fixamount_desc: '按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                maxdiff_desc: '按 即 月 交 易 量 達 到 的 內 返 條 件 , 與 最 高 內 返 條 件 的 相 差 來 分 配 佣 金  。相 差 的 金 額 以 輸 入 的 上 限 由 下 到 上 來 分 配 。',
                fixamountnonvip_desc: '針 對 普 通 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
                fixamountvip_desc: '針 對 V I P 組 別 的 客 戶 , 按 照 輸 入 的 金 額 計 算 佣 金  ，佣 金 是 公 司 額 外 提 供  ，而 不 是 由 現 有 佣 金 分 配 。',
            },
            products: {
                ALL: '全部',

                FX: '外匯',
                FX_VIP: '外匯(VIP)',
                GOLD: '黃金',
                GOLD_VIP: '黃金(VIP)',
                SILVER: '白銀',
                SILVER_VIP: '白銀(VIP)',
                ENERGY: '能源',
                ENERGY_VIP: '能源(VIP)',
                INDEX: '指數',
                INDEX_VIP: '指數(VIP)',
                FX_MAJOR: '外匯(主要)',
                FX_MAJOR_VIP: '外匯(主要)(VIP)',
                FX_MINOR: '外匯(次要)',
                FX_MINOR_VIP: '外匯(次要)(VIP)',
                FX_EXOTIC: '外匯(其他)',
                FX_EXOTIC_VIP: '外匯(其他)(VIP)',
                BTC: '比特幣',
                BTC_VIP: '比特幣(VIP)',
                ETH_LTC: '以太幣&萊特幣',
                ETH_LTC_VIP: '以太幣&萊特幣(VIP)',
                FUTURE_GOLD: '黃金期貨',
                FUTURE_GOLD_VIP: '黃金期貨(VIP)',
                FUTURE_SILVER: '白銀期貨',
                FUTURE_SILVER_VIP: '白銀期貨(VIP)',
                FUTURE_COPPER: '黃銅期貨',
                FUTURE_COPPER_VIP: '黃銅期貨(VIP)',
                FUTURE_NATGAS: '天然氣期貨',
                FUTURE_NATGAS_VIP: '天然氣期貨(VIP)',
                COPPER: '銅',
                COPPER_VIP: '銅(VIP)',
            },
            detailTh: {
                IB_ID: '代理賬號',
                CLIENT_ID: '客戶賬號',
                PLATFORM: '交易平台',
                TRADING_ACCOUNT_ID: '交易賬號',

                FX_LOT: '外匯(手數)',
                FX_REBATE_DIFF: '外匯(每手差值)',
                FX_COMMISSION_DIFF: '外匯(額外佣金)',
                FX_VIP_LOT: '外匯(VIP)(手數)',
                FX_VIP_REBATE_DIFF: '外匯(VIP)(每手差值)',
                FX_VIP_COMMISSION_DIFF: '外匯(VIP)(額外佣金)',

                GOLD_LOT: '黃金(手數)',
                GOLD_REBATE_DIFF: '黃金(每手差值)',
                GOLD_COMMISSION_DIFF: '黃金(額外佣金)',
                GOLD_VIP_LOT: '黃金(VIP)(手數)',
                GOLD_VIP_REBATE_DIFF: '黃金(VIP)(每手差值)',
                GOLD_VIP_COMMISSION_DIFF: '黃金(VIP)(額外佣金)',

                SILVER_LOT: '白銀(手數)',
                SILVER_REBATE_DIFF: '白銀(每手差值)',
                SILVER_COMMISSION_DIFF: '白銀(額外佣金)',
                SILVER_VIP_LOT: '白銀(VIP)(手數)',
                SILVER_VIP_REBATE_DIFF: '白銀(VIP)(每手差值)',
                SILVER_VIP_COMMISSION_DIFF: '白銀(VIP)(額外佣金)',

                ENERGY_LOT: '能源(手數)',
                ENERGY_REBATE_DIFF: '能源(每手差值)',
                ENERGY_COMMISSION_DIFF: '能源(額外佣金)',
                ENERGY_VIP_LOT: '能源((VIP)(手數)',
                ENERGY_VIP_REBATE_DIFF: '能源((VIP)(每手差值)',
                ENERGY_VIP_COMMISSION_DIFF: '能源((VIP)(額外佣金)',

                INDEX_LOT: '指數(手數)',
                INDEX_REBATE_DIFF: '指數(每手差值)',
                INDEX_COMMISSION_DIFF: '指數(額外佣金)',
                INDEX_VIP_LOT: '指數(VIP)(手數)',
                INDEX_VIP_REBATE_DIFF: '指數(VIP)(每手差值)',
                INDEX_VIP_COMMISSION_DIFF: '指數(VIP)(額外佣金)',

                FX_MAJOR_LOT: '外匯(主要)(手數)',
                FX_MAJOR_REBATE_DIFF: '外匯(主要)(每手差值)',
                FX_MAJOR_COMMISSION_DIFF: '外匯(主要)(額外佣金)',
                FX_MAJOR_VIP_LOT: '外匯(主要)(VIP)(手數)',
                FX_MAJOR_VIP_REBATE_DIFF: '外匯(主要)(VIP)(每手差值)',
                FX_MAJOR_VIP_COMMISSION_DIFF: '外匯(主要)(VIP)(額外佣金)',

                FX_MINOR_LOT: '外匯(次要)(手數)',
                FX_MINOR_REBATE_DIFF: '外匯(次要)(每手差值)',
                FX_MINOR_COMMISSION_DIFF: '外匯(次要)(額外佣金)',
                FX_MINOR_VIP_LOT: '外匯(次要)(VIP)(手數)',
                FX_MINOR_VIP_REBATE_DIFF: '外匯(次要)(VIP)(每手差值)',
                FX_MINOR_VIP_COMMISSION_DIFF: '外匯(次要)(VIP)(額外佣金)',

                FX_EXOTIC_LOT: '外匯(其他)(手數)',
                FX_EXOTIC_REBATE_DIFF: '外匯(其他)(每手差值)',
                FX_EXOTIC_COMMISSION_DIFF: '外匯(其他)(額外佣金)',
                FX_EXOTIC_VIP_LOT: '外匯(其他)(VIP)(手數)',
                FX_EXOTIC_VIP_REBATE_DIFF: '外匯(其他)(VIP)(每手差值)',
                FX_EXOTIC_VIP_COMMISSION_DIFF: '外匯(其他)(VIP)(額外佣金)',

                BTC_LOT: '比特幣(手數)',
                BTC_REBATE_DIFF: '比特幣(每手差值)',
                BTC_COMMISSION_DIFF: '比特幣(額外佣金)',
                BTC_VIP_LOT: '比特幣(VIP)(手數)',
                BTC_VIP_REBATE_DIFF: '比特幣(VIP)(每手差值)',
                BTC_VIP_COMMISSION_DIFF: '比特幣(VIP)(額外佣金)',

                ETH_LTC_LOT: '以太幣&萊特幣(手數)',
                ETH_LTC_REBATE_DIFF: '以太幣&萊特幣(每手差值)',
                ETH_LTC_COMMISSION_DIFF: '以太幣&萊特幣(額外佣金)',
                ETH_LTC_VIP_LOT: '以太幣&萊特幣(VIP)(手數)',
                ETH_LTC_VIP_REBATE_DIFF: '以太幣&萊特幣(VIP)(每手差值)',
                ETH_LTC_VIP_COMMISSION_DIFF: '以太幣&萊特幣(VIP)(額外佣金)',

                FUTURE_GOLD_LOT: '黃金期貨(手數)',
                FUTURE_GOLD_REBATE_DIFF: '黃金期貨(每手差值)',
                FUTURE_GOLD_COMMISSION_DIFF: '黃金期貨(額外佣金)',
                FUTURE_GOLD_VIP_LOT: '黃金期貨(VIP)(手數)',
                FUTURE_GOLD_VIP_REBATE_DIFF: '黃金期貨(VIP)(每手差值)',
                FUTURE_GOLD_VIP_COMMISSION_DIFF: '黃金期貨(VIP)(額外佣金)',

                FUTURE_SILVER_LOT: '白銀期貨(手數)',
                FUTURE_SILVER_DIFF: '白銀期貨(每手差值)',
                FUTURE_SILVER_COMMISSION_DIFF: '白銀期貨(額外佣金)',
                FUTURE_SILVER_VIP_LOT: '白銀期貨(VIP)(手數)',
                FUTURE_SILVER_VIP_REBATE_DIFF: '白銀期貨(VIP)(每手差值)',
                FUTURE_SILVER_VIP_COMMISSION_DIFF: '白銀期貨(VIP)(額外佣金)',

                FUTURE_COPPER_LOT: '黃銅期貨(手數)',
                FUTURE_COPPER_REBATE_DIFF: '黃銅期貨(每手差值)',
                FUTURE_COPPER_COMMISSION_DIFF: '黃銅期貨(額外佣金)',
                FUTURE_COPPER_VIP_LOT: '黃銅期貨(VIP)(手數)',
                FUTURE_COPPER_VIP_REBATE_DIFF: '黃銅期貨(VIP)(每手差值)',
                FUTURE_COPPER_VIP_COMMISSION_DIFF: '黃銅期貨(VIP)(額外佣金)',

                FUTURE_NATGAS_LOT: '天然氣期貨(手數)',
                FUTURE_NATGAS_REBATE_DIFF: '天然氣期貨(每手差值)',
                FUTURE_NATGAS_COMMISSION_DIFF: '天然氣期貨(額外佣金)',
                FUTURE_NATGAS_VIP_LOT: '天然氣期貨(VIP)(手數)',
                FUTURE_NATGAS_VIP_REBATE_DIFF: '天然氣期貨(VIP)(每手差值)',
                FUTURE_NATGAS_VIP_COMMISSION_DIFF: '天然氣期貨(VIP)(額外佣金)',

                COPPER_LOT: '銅(手數)',
                COPPER_REBATE_DIFF: '銅(每手差值)',
                COPPER_COMMISSION_DIFF: '銅(額外傭金)',
                COPPER_VIP_LOT: '銅(VIP)(手數)',
                COPPER_VIP_REBATE_DIFF: '銅(VIP)(每手差值)',
                COPPER_VIP_COMMISSION_DIFF: '銅(VIP)(額外傭金)',
            },
            notNumber: '不是正整數，請檢查輸入'
        }
    },
    en: {
        publicLan: {
            type: {
                SL: 'Sales',
                M: 'Manager',
                IB: 'IB',
                CL: 'Client',
                extraEmployee: 'Extra Employee',
                specialIB: 'Special IB',
                employee: 'Employee',
                UN: "System",
                C: 'Company',
                N: 'Country',
                R: 'Region',
                O: 'Office',
                M: 'Manager',
            },
            relationType: {
                relation: 'Relation',
                extra: 'Extra',
                special: 'Special'
            },
            clientType: {
                allClient: 'All Client',
                IBClient: 'IB Client',
                directClient: 'Direct Client',
            },
            rule: {
                percentage: "Percentage",
                extrapercentage: "Extrapercentage",
                maxlevel: "Maxlevel",
                fixamount: "Fixamount",
                maxlevel2: "Maxlevel",
                maxdiff: "Maxdiff",
                fixamountnonvip: "Fixamount(Common Group)",
                fixamountvip: "Fixamount(VIP Group)",
                percentage_desc: 'percentage_desc',
                extrapercentage_desc: 'extrapercentage_desc',
                maxlevel_desc: 'maxlevel_desc',
                maxlevel2_desc: 'maxlevel2_desc',
                fixamount_desc: 'fixamount_desc',
                maxdiff_desc: 'maxdiff_desc',
                fixamountnonvip_desc: 'fixamountnonvip_desc',
                fixamountvip_desc: 'fixamountvip_desc'
            },
            products: {
                ALL: 'ALL',

                FX: 'FX',
                FX_VIP: 'FX(VIP)',
                GOLD: 'GOLD',
                GOLD_VIP: 'GOLD(VIP)',
                SILVER: 'SILVER',
                SILVER_VIP: 'SILVER(VIP)',
                ENERGY: 'ENERGY',
                ENERGY_VIP: 'ENERGY(VIP)',
                INDEX: 'INDEX',
                INDEX_VIP: 'INDEX(VIP)',
                FX_MAJOR: 'FX MAJOR',
                FX_MAJOR_VIP: 'FX MAJOR(VIP)',
                FX_MINOR: 'FX MINOR',
                FX_MINOR_VIP: 'FX MINOR(VIP)',
                FX_EXOTIC: 'FX EXOTIC',
                FX_EXOTIC_VIP: 'FX EXOTIC(VIP)',
                BTC: 'BTC',
                BTC_VIP: 'BTC(VIP)',
                ETH_LTC: 'ETH / LTC',
                ETH_LTC_VIP: 'ETH / LTC(VIP)',
                FUTURE_GOLD: 'FUTURE GOLD',
                FUTURE_GOLD_VIP: 'FUTURE GOLD(VIP)',
                FUTURE_SILVER: 'FUTURE SILVER',
                FUTURE_SILVER_VIP: 'FUTURE SILVER(VIP)',
                FUTURE_COPPER: 'FUTURE COPPER',
                FUTURE_COPPER_VIP: 'FUTURE COPPER(VIP)',
                FUTURE_NATGAS: 'FUTURE NATGAS',
                FUTURE_NATGAS_VIP: 'FUTURE NATGAS(VIP)',
                COPPER: 'COPPER',
                COPPER_VIP: 'COPPER(VIP)',
            },
            detailTh: {
                IB_ID: 'IB Account',
                CLIENT_ID: 'CLIENT ID',
                PLATFORM: 'Trading Platform',
                TRADING_ACCOUNT_ID: 'Trading Account',

                FX_LOT: 'FX(LOTS)',
                FX_REBATE_DIFF: 'FX(Rebate Diff.)',
                FX_COMMISSION_DIFF: 'FX(Commission Diff.)',
                FX_VIP_LOT: 'FX(VIP)(LOTS)',
                FX_VIP_REBATE_DIFF: 'FX(VIP)(Rebate Diff.)',
                FX_VIP_COMMISSION_DIFF: 'FX(VIP)(Commission Diff.)',

                GOLD_LOT: 'GOLD(LOTS)',
                GOLD_REBATE_DIFF: 'GOLD(Rebate Diff.)',
                GOLD_COMMISSION_DIFF: 'GOLD(Commission Diff.)',
                GOLD_VIP_LOT: 'GOLD(VIP)(LOTS)',
                GOLD_VIP_REBATE_DIFF: 'GOLD(VIP)(Rebate Diff.)',
                GOLD_VIP_COMMISSION_DIFF: 'GOLD(VIP)(Commission Diff.)',

                SILVER_LOT: 'SILVER(LOTS)',
                SILVER_REBATE_DIFF: 'SILVER(Rebate Diff.)',
                SILVER_COMMISSION_DIFF: 'SILVER(Commission Diff.)',
                SILVER_VIP_LOT: 'SILVER(VIP)(LOTS)',
                SILVER_VIP_REBATE_DIFF: 'SILVER(VIP)(Rebate Diff.)',
                SILVER_VIP_COMMISSION_DIFF: 'SILVER(VIP)(Commission Diff.)',

                ENERGY_LOT: 'ENERGY(LOTS)',
                ENERGY_REBATE_DIFF: 'ENERGY(Rebate Diff.)',
                ENERGY_COMMISSION_DIFF: 'ENERGY(Commission Diff.)',
                ENERGY_VIP_LOT: 'ENERGY((VIP)(LOTS)',
                ENERGY_VIP_REBATE_DIFF: 'ENERGY((VIP)(Rebate Diff.)',
                ENERGY_VIP_COMMISSION_DIFF: 'ENERGY((VIP)(Commission Diff.)',

                INDEX_LOT: 'INDEX(LOTS)',
                INDEX_REBATE_DIFF: 'INDEX(Rebate Diff.)',
                INDEX_COMMISSION_DIFF: 'INDEX(Commission Diff.)',
                INDEX_VIP_LOT: 'INDEX(VIP)(LOTS)',
                INDEX_VIP_REBATE_DIFF: 'INDEX(VIP)(Rebate Diff.)',
                INDEX_VIP_COMMISSION_DIFF: 'INDEX(VIP)(Commission Diff.)',

                FX_MAJOR_LOT: 'FX MAJOR(LOTS)',
                FX_MAJOR_REBATE_DIFF: 'FX MAJOR(Rebate Diff.)',
                FX_MAJOR_COMMISSION_DIFF: 'FX MAJOR(Commission Diff.)',
                FX_MAJOR_VIP_LOT: 'FX MAJOR(VIP)(LOTS)',
                FX_MAJOR_VIP_REBATE_DIFF: 'FX MAJOR(VIP)(Rebate Diff.)',
                FX_MAJOR_VIP_COMMISSION_DIFF: 'FX MAJOR(VIP)(Commission Diff.)',

                FX_MINOR_LOT: 'FX MINOR(LOTS)',
                FX_MINOR_REBATE_DIFF: 'FX MINOR(Rebate Diff.)',
                FX_MINOR_COMMISSION_DIFF: 'FX MINOR(Commission Diff.)',
                FX_MINOR_VIP_LOT: 'FX MINOR(VIP)(LOTS)',
                FX_MINOR_VIP_REBATE_DIFF: 'FX MINOR(VIP)(Rebate Diff.)',
                FX_MINOR_VIP_COMMISSION_DIFF: 'FX MINOR(VIP)(Commission Diff.)',

                FX_EXOTIC_LOT: 'FX EXOTIC(LOTS)',
                FX_EXOTIC_REBATE_DIFF: 'FX EXOTIC(Rebate Diff.)',
                FX_EXOTIC_COMMISSION_DIFF: 'FX EXOTIC(Commission Diff.)',
                FX_EXOTIC_VIP_LOT: 'FX EXOTIC(VIP)(LOTS)',
                FX_EXOTIC_VIP_REBATE_DIFF: 'FX EXOTIC(VIP)(Rebate Diff.)',
                FX_EXOTIC_VIP_COMMISSION_DIFF: 'FX EXOTIC(VIP)(Commission Diff.)',

                BTC_LOT: 'BTC(LOTS)',
                BTC_REBATE_DIFF: 'BTC(Rebate Diff.)',
                BTC_COMMISSION_DIFF: 'BTC(Commission Diff.)',
                BTC_VIP_LOT: 'BTC(VIP)(LOTS)',
                BTC_VIP_REBATE_DIFF: 'BTC(VIP)(Rebate Diff.)',
                BTC_VIP_COMMISSION_DIFF: 'BTC(VIP)(Commission Diff.)',

                ETH_LTC_LOT: 'ETH / LTC(LOTS)',
                ETH_LTC_REBATE_DIFF: 'ETH / LTC(Rebate Diff.)',
                ETH_LTC_COMMISSION_DIFF: 'ETH / LTC(Commission Diff.)',
                ETH_LTC_VIP_LOT: 'ETH / LTC(VIP)(LOTS)',
                ETH_LTC_VIP_REBATE_DIFF: 'ETH / LTC(VIP)(Rebate Diff.)',
                ETH_LTC_VIP_COMMISSION_DIFF: 'ETH / LTC(VIP)(Commission Diff.)',

                FUTURE_GOLD_LOT: 'FUTURE GOLD(LOTS)',
                FUTURE_GOLD_REBATE_DIFF: 'FUTURE GOLD(Rebate Diff.)',
                FUTURE_GOLD_COMMISSION_DIFF: 'FUTURE GOLD(Commission Diff.)',
                FUTURE_GOLD_VIP_LOT: 'FUTURE GOLD(VIP)(LOTS)',
                FUTURE_GOLD_VIP_REBATE_DIFF: 'FUTURE GOLD(VIP)(Rebate Diff.)',
                FUTURE_GOLD_VIP_COMMISSION_DIFF: 'FUTURE GOLD(VIP)(Commission Diff.)',

                FUTURE_SILVER_LOT: 'FUTURE SILVER(LOTS)',
                FUTURE_SILVER_DIFF: 'FUTURE SILVER(Rebate Diff.)',
                FUTURE_SILVER_COMMISSION_DIFF: 'FUTURE SILVER(Commission Diff.)',
                FUTURE_SILVER_VIP_LOT: 'FUTURE SILVER(VIP)(LOTS)',
                FUTURE_SILVER_VIP_REBATE_DIFF: 'FUTURE SILVER(VIP)(Rebate Diff.)',
                FUTURE_SILVER_VIP_COMMISSION_DIFF: 'FUTURE SILVER(VIP)(Commission Diff.)',

                FUTURE_COPPER_LOT: 'FUTURE COPPER(LOTS)',
                FUTURE_COPPER_REBATE_DIFF: 'FUTURE COPPER(Rebate Diff.)',
                FUTURE_COPPER_COMMISSION_DIFF: 'FUTURE COPPER(Commission Diff.)',
                FUTURE_COPPER_VIP_LOT: 'FUTURE COPPER(VIP)(LOTS)',
                FUTURE_COPPER_VIP_REBATE_DIFF: 'FUTURE COPPER(VIP)(Rebate Diff.)',
                FUTURE_COPPER_VIP_COMMISSION_DIFF: 'FUTURE COPPER(VIP)(Commission Diff.)',

                FUTURE_NATGAS_LOT: 'FUTURE NATGAS(LOTS)',
                FUTURE_NATGAS_REBATE_DIFF: 'FUTURE NATGAS(Rebate Diff.)',
                FUTURE_NATGAS_COMMISSION_DIFF: 'FUTURE NATGAS(Commission Diff.)',
                FUTURE_NATGAS_VIP_LOT: 'FUTURE NATGAS(VIP)(LOTS)',
                FUTURE_NATGAS_VIP_REBATE_DIFF: 'FUTURE NATGAS(VIP)(Rebate Diff.)',
                FUTURE_NATGAS_VIP_COMMISSION_DIFF: 'FUTURE NATGAS(VIP)(Commission Diff.)',


                COPPER_LOT: 'COPPER(LOTS)',
                COPPER_REBATE_DIFF: 'COPPER(Rebate Diff.)',
                COPPER_COMMISSION_DIFF: 'COPPER(Commission Diff.)',
                COPPER_VIP_LOT: 'COPPER(VIP)(LOTS)',
                COPPER_VIP_REBATE_DIFF: 'COPPER(VIP)(Rebate Diff.)',
                COPPER_VIP_COMMISSION_DIFF: 'COPPER(VIP)(Commission Diff.)',
            },
            notNumber: ' is not a number, please check your input'
        }
    }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/publicLan.js